import styled from "@emotion/styled";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {
  Box,
  Container,
  IconButton,
  Link,
  List,
  ListItem,
  Paper,
  Typography,
} from "@mui/material";
import { bottomFooter, icons, productServices } from "./layout.constant";

const SpanItem = styled.span({
  fontSize: "var(--cf-local-13-size, 13px)",
  fontWeight: 400,
  color: "#fff",
  lineHeight: "15.12px",
});

const SocialIcon = styled.img({
  height: "36px",
  width: "36px",
  borderRadius: "36px",
});

export const CovestroFooter = () => {
  const handleScrollTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const handleRouteChange = (route: string) => {
    if (route.length > 0) {
      window.open(route);
    } else {
      return;
    }
  };

  return (
    <>
      <Paper sx={{ width: "100%", minHeight: 358, backgroundColor: "#1A1A1A" }}>
        <Container maxWidth={"xxl"} sx={{ padding: "0px !important" }}>
          <Box
            sx={{
              padding: { xs: "32px 16px", sm: "48px 32px", lg: "64px 125px" },
              flexDirection: { xs: "column", md: "row" },
              display: "flex",
              gap: { xs: 4, md: 0 },
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", md: "40%" },
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: "var(--body-b2-14-regular-size, 14px)",
                  fontWeight: 700,
                  lineHeight: "18.03px",
                  paddingRight: 0,
                  marginBottom: "12px",
                }}
                variant="h6"
              >
                Our Products & Services
              </Typography>
              <List
                sx={{ flexDirection: "column", display: "flex", gap: "8px" }}
                dense
              >
                {productServices.map((v) => (
                  <ListItem
                    key={v.text}
                    sx={{
                      padding: 0,
                      fontWeight: 400,
                      fontSize: "var(--cf-local-13-size, 13px)",
                      opacity: 0.8,
                      "&:hover": {
                        color: "#fff",
                        opacity: 1,
                      },
                    }}
                  >
                    <Link
                      component="button"
                      onClick={() => handleRouteChange(v.route)}
                      underline="none"
                      title={v.text}
                    >
                      <SpanItem>{v.text}</SpanItem>
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Box>
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                flexDirection: "column",
                textAlign: "left",
              }}
            >
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: "var(--cf-local-15-size, 15px)",
                  fontWeight: 700,
                  lineHeight: "24px",
                  paddingRight: 0,
                  marginBottom: "12px",
                  width: "100%",
                }}
                variant="h6"
                component="div"
              >
                About us
              </Typography>
              <Box sx={{ padding: 0, marginBottom: "32px" }}>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "var(--cf-local-13-size, 13px)",
                    fontWeight: 400,
                    lineHeight: "15.12px",
                    paddingRight: 0,
                    marginBottom: "32px",
                    opacity: 0.8,
                    "&:hover": {
                      color: "#fff",
                      opacity: 1,
                    },
                  }}
                  component="p"
                >
                  Covestro is a world-leading supplier of high-tech polymer
                  materials: innovative, sustainable and diverse.
                </Typography>
                <Link
                  component="button"
                  onClick={() => handleRouteChange("https://www.covestro.com/")}
                >
                  <SpanItem>www.covestro.com</SpanItem>
                </Link>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  padding: 0,
                  marginLeft: 0,
                  position: "relative",
                }}
              >
                <List
                  sx={{
                    padding: 0,
                    flexDirection: "row",
                    display: "flex",
                    gap: "16px",
                    position: "absolute",
                    left: 0,
                  }}
                  dense
                >
                  {icons.map((icon) => (
                    <ListItem key={icon.name} sx={{ padding: 0 }}>
                      <Link
                        component="button"
                        onClick={() => handleRouteChange(icon.link)}
                      >
                        <SocialIcon src={icon.icon} />
                      </Link>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>
            <Box
              sx={{
                width: { xs: "100%", md: "10%" },
                textAlign: { xs: "left", md: "right" },
                margin: { xs: 0, md: "auto" },
              }}
            >
              <IconButton
                onClick={() => handleScrollTop()}
                sx={{
                  color: "#fff",
                  width: "32px",
                  height: "32px",
                  borderRadius: "2px",
                  backgroundColor: "#393939",
                  transition: "background-color .15s ease-in",
                  "&:hover": {
                    backgroundColor: "#5f5f5f",
                    color: "#fff",
                    transition: "background-color .15s ease-in",
                  },
                }}
              >
                <ExpandLessIcon fontSize="medium" />
              </IconButton>
            </Box>
          </Box>
        </Container>
      </Paper>
      <Paper
        sx={{
          width: "100%",
          minHeight: "52px",
          backgroundColor: "#000",
        }}
      >
        <Container maxWidth={"xxl"} sx={{ padding: "0px !important" }}>
          <Box
            sx={{
              width: "100%",
              padding: { xs: "12px 16px", sm: "0 32px", lg: "0 125px" },
              flexDirection: { xs: "column", md: "row" },
              display: "flex",
              gap: { xs: 1, md: 0 },
            }}
          >
            <Box sx={{ width: { xs: "100%", md: "50%" } }}>
              <List
                sx={{
                  padding: "16px 0",
                  flexDirection: "row",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "20px",
                }}
                dense
              >
                {bottomFooter.map((v, _i) => (
                  <ListItem
                    sx={{
                      paddingLeft: 0,
                      width: "auto",
                      whiteSpace: "nowrap",
                      opacity: 0.8,
                      "&:hover": { opacity: 1 },
                      ":first-of-type": { marginRight: "20px" },
                    }}
                    key={v.text}
                  >
                    <Link
                      component="button"
                      onClick={() => handleRouteChange(v.route)}
                      title={v.text}
                      underline="none"
                    >
                      <SpanItem>{v.text}</SpanItem>
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Box>
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                textAlign: { xs: "left", md: "right" },
                paddingTop: { xs: 0, md: "16px" },
                paddingBottom: { xs: "8px", md: 0 },
              }}
            >
              <SpanItem>
                Copyright © {new Date().getFullYear()} Covestro AG
              </SpanItem>
            </Box>
          </Box>
        </Container>
      </Paper>
    </>
  );
};
